import { css } from 'styled-components';

const variables = css`
  :root {
    /* Palette: paper + ink, with a violet accent.
       The variable names (navy / green / slate) are inherited from the v4
       template and describe each colour's ROLE, not its hue — --navy is the
       page background, --green the accent, --slate the body text. On this
       light palette the roles are inverted relative to the original: --navy
       is the lightest surface and --white the darkest ink. */

    --dark-navy: #f0eee9;
    --navy: #faf9f7;
    --light-navy: #f2f0f6;
    --lightest-navy: #ddd7e8;
    --navy-shadow: rgba(28, 25, 23, 0.12);
    --navy-translucent: rgba(250, 249, 247, 0.9);
    --dark-slate: #8b8580;
    --slate: #57534e;
    --light-slate: #3b3835;
    --lightest-slate: #1c1917;
    --white: #000000;
    --green: #7c3aed;
    --green-tint: rgba(124, 58, 237, 0.1);
    --pink: #9d174d;
    --blue: #1e40af;

    --font-sans: 'Calibre', 'Inter', 'San Francisco', 'SF Pro Text', -apple-system, system-ui,
      sans-serif;
    --font-mono: 'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace;

    --fz-xxs: 12px;
    --fz-xs: 13px;
    --fz-sm: 14px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 22px;
    --fz-heading: 32px;

    --border-radius: 4px;
    --nav-height: 100px;
    --nav-scroll-height: 70px;

    --tab-height: 42px;
    --tab-width: 120px;

    --easing: cubic-bezier(0.645, 0.045, 0.355, 1);
    --transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);

    --hamburger-width: 30px;

    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out,
      transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
